import { useState, useEffect } from 'react';

export default selector => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const targets = document.querySelectorAll(selector);
    const images = Array.from(targets).filter(node => node.nodeName === 'IMG');
    setImages(images);
  }, [selector]);

  return images;
};
